// src/i18n/es/zones.js
export const zones = {
    name: 'Zona |||| Zonas',
    title: 'Gestión de Zonas',
    titles: {
        list: 'Zonas',
        create: 'Nueva Zona',
        edit: 'Editar Zona',
        manage: 'Gestionar Zonas',
    },
    fields: {
        id: 'ID',
        name: 'Nombre',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        description: 'Descripción',
        lockerCount: 'Total de taquillas',
        availableCount: 'Disponibles',
        occupiedCount: 'Ocupadas',
        maintenanceCount: 'En mantenimiento',
        createdAt: 'Creada',
        updatedAt: 'Actualizada',
    },
    actions: {
        create: 'Nueva Zona',
        edit: 'Editar',
        delete: 'Eliminar',
        view_lockers: 'Ver taquillas',
        add_lockers: 'Añadir taquillas',
    },
    messages: {
        no_zones: 'No hay zonas configuradas',
        loading: 'Cargando zonas...',
        create_success: 'Zona creada correctamente',
        update_success: 'Zona actualizada correctamente',
        delete_success: 'Zona eliminada correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar esta zona?',
        has_lockers: 'Esta zona tiene taquillas asignadas',
    },
    validation: {
        name_required: 'El nombre de la zona es obligatorio',
        name_exists: 'Ya existe una zona con ese nombre',
    },
    dialogs: {
        delete_title: 'Eliminar Zona',
        delete_message: '¿Está seguro de que desea eliminar la zona %{name}?',
        delete_warning: 'Esta acción afectará a todas las taquillas en esta zona.',
    },
    placeholders: {
        name: 'Ej: Piscina, Gimnasio, Recepción',
        description: 'Descripción opcional de la zona',
    },
};

// src/i18n/es/tags.js
export const tags = {
    name: 'ID |||| IDs',
    title: 'Gestión de IDs',
    titles: {
        list: 'IDs',
        create: 'Nueva ID',
        edit: 'Editar ID',
        assign: 'Asignar ID',
    },
    fields: {
        id: 'ID',
        uid: 'UID',
        typeCode: 'Tipo',
        type_code: 'Código de Tipo',
        typeName: 'Tipo',
        description: 'Descripción',
        data: 'Datos',
        isActive: 'Activa',
        assignment: 'Asignación',
        assignmentId: 'ID de Asignación',
        hotel: 'Hotel',
        createdAt: 'Creada',
        updatedAt: 'Actualizada',
    },
    types: {
        card: 'Tarjeta',
        wristband: 'Pulsera',
        keychain: 'Llavero',
        mobile: 'Móvil',
        other: 'Otro',
    },
    status: {
        active: 'Activa',
        inactive: 'Inactiva',
        assigned: 'Asignada',
        lost: 'Perdida',
        damaged: 'Dañada',
    },
    actions: {
        create: 'Nueva ID',
        edit: 'Editar',
        delete: 'Eliminar',
        assign: 'Asignar',
        unassign: 'Desasignar',
        activate: 'Activar',
        deactivate: 'Desactivar',
        read: 'Leer ID',
        write: 'Escribir datos',
    },
    messages: {
        no_tags: 'No se encontraron IDs',
        loading: 'Cargando IDs...',
        create_success: 'ID creada correctamente',
        update_success: 'ID actualizada correctamente',
        delete_success: 'ID eliminada correctamente',
        assign_success: 'ID asignada correctamente',
        unassign_success: 'ID desasignada correctamente',
        read_success: 'ID leída correctamente',
        write_success: 'Datos escritos correctamente',
        invalid_uid: 'UID de ID no válido',
        already_assigned: 'Esta ID ya está asignada',
    },
    validation: {
        uid_required: 'El UID es obligatorio',
        uid_format: 'El formato del UID no es válido',
        type_required: 'El tipo de ID es obligatorio',
    },
    dialogs: {
        delete_title: 'Eliminar ID',
        delete_message: '¿Está seguro de que desea eliminar esta ID?',
        assign_title: 'Asignar ID',
        assign_message: 'Seleccione la asignación para esta ID',
    },
};

